import { getCollectionEntitySegment } from '#app/utils/pz/brand/collectionEntity'
import { getMainEntitySegment } from '#app/utils/pz/brand/mainEntity'

const PROGRAM_INDEX_ALLOWED_PARAMS = ['q', 'page', 'level', 'language', 'sort']

export function getPublicTracksIndexPath() {
	return `/${getMainEntitySegment('marketing')}`
}

export function getPublicProgramsIndexPath() {
	return `/${getCollectionEntitySegment('marketing')}`
}

export function getPublicCatalogIndexPath() {
	return '/catalog'
}

export function getPublicProgramDetailPath(slug: string) {
	return `${getPublicProgramsIndexPath()}/${slug}`
}

export function getLegacyProgramIndexRedirectUrl(requestUrl: string) {
	const url = new URL(requestUrl)
	const tracksIndexPath = getPublicTracksIndexPath()

	if (url.pathname !== tracksIndexPath) return null
	if (url.searchParams.get('type') !== 'collection') return null

	const redirectUrl = new URL(url.toString())
	const nextParams = new URLSearchParams()

	for (const paramName of PROGRAM_INDEX_ALLOWED_PARAMS) {
		const value = url.searchParams.get(paramName)
		if (value) nextParams.set(paramName, value)
	}

	redirectUrl.pathname = getPublicProgramsIndexPath()
	redirectUrl.search = nextParams.toString()
	return redirectUrl.toString()
}
